import { render, staticRenderFns } from "./TopupHistory.vue?vue&type=template&id=37950c44&"
import script from "./TopupHistory.vue?vue&type=script&lang=js&"
export * from "./TopupHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports